// extracted by mini-css-extract-plugin
export var dateLabel = "_2y-0";
export var dateLabelError = "_2y-1";
export var fullWidth = "_2y-2";
export var smaller = "_2y-3";